
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'replicar',
        label: 'Replicar Medição para os Seguintes GHE',
        multiple:[],
        option: {
            key: 'id',
            label: 'ghe',
            value: 'id'
        },
        title: {
            model: 'replicar_subs',
        },
        info: 'Caso essa medição seja igual em vários GHE, você pode replicar essa configuração em vez de cadastrar individualmente para cada setor.',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_con_tec',
        label: 'Selecionar uma Conclusão Técnica Existente',
        option: {
            key: 'id',
            label: 'nome',
            value: 'object'
        },
        info:'Para incluir uma conclusão técnica na base de dados, acesse o menú LTCAT > Confgurações > Conclusão Técnica',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'nome',
        label: 'Nome',
        maxlength:255,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'descricao',
        label: 'Descrição',
        rules: ['required']
    },
    // {
    //     class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    //     type: 'boolean',
    //     field: 'inserir',
    //     label: 'Inserir essa Conclusão na Base de Dados',
    //     info: 'Se esse campo estiver habilitado, o sistema vai inserir essa conclusão técnica na base de dados para ser utilizado nos próximos cadastros',
    //     rules: ['required']
    // },

];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/ghe/_form/ltcat-ghe-conclusao-cadastrar.js